import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  clientConfig() {
    return window['ftClientConfig'];
  }
}
